import { firebaseApp } from "../firebase";
import { getDatabase, ref, push, get, child, update } from "firebase/database";

const state = {
  calcs: [],
  calcsUser: [],
  orcamento: {},
  showMostruario: false,
  mostruario: null,
};

const getters = {
  calcs(state) {
    return state.calcs;
  },
  calcsUser(state) {
    return state.calcs;
  },
  orcamento(state) {
    return state.orcamento;
  },
  showMostruario(state) {
    return state.showMostruario;
  },
  mostruario(state) {
    return state.mostruario;
  },
};

const actions = {
  setShowMostruario({ commit }, value) {
    commit("setShowMostruario", value);
  },
  setMostruario({ commit }, value) {
    commit("setMostruario", value);
  },
  setViewTrue({ dispatch }, id) {
    const db = getDatabase(firebaseApp);
    const updates = {};
    updates["calcs/" + id + "/view/"] = true;
    update(ref(db), updates);
    dispatch("loadCalcs");
  },
  loadCalcs({ commit }) {
    const db = getDatabase(firebaseApp);
    const dbRef = ref(db);
    get(child(dbRef, "calcs/"))
      .then((snapshot) => {
        if (snapshot.exists()) {
          const calcs = [];
          const obj = snapshot.val();
          for (const key in obj) {
            calcs.push({
              id: key,
              data: obj[key].data,
              clienteEmail: obj[key].clienteEmail,
              clienteId: obj[key].clienteId,
              tipo: obj[key].tipo,
              capa: obj[key].capa,
              mostruario: obj[key].mostruario,
              laminacao: obj[key].laminacao,
              acessorios: obj[key].acessorios,
              tamanho: obj[key].tamanho,
              laminas: obj[key].laminas,
              extras: obj[key].extras,
              obs: obj[key].obs,
              valor: obj[key].valor,
              view: obj[key].view,
              save: obj[key].save,
            });
          }
          commit("setCalcs", calcs);
        } else {
          console.log("Dados não encontrados.");
          commit("setCalcs", []);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
  loadCalcsUser({ commit }, id) {
    const db = getDatabase(firebaseApp);
    const dbRef = ref(db);
    get(child(dbRef, "calcs/"))
      .then((snapshot) => {
        if (snapshot.exists()) {
          const calcs = [];
          const obj = snapshot.val();
          for (const key in obj) {
            if (obj[key].clienteId === id && obj[key].save === "Salvo") {
              calcs.push({
                id: key,
                data: obj[key].data,
                clienteEmail: obj[key].clienteEmail,
                clienteId: obj[key].clienteId,
                tipo: obj[key].tipo,
                capa: obj[key].capa,
                mostruario: obj[key].mostruario,
                laminacao: obj[key].laminacao,
                acessorios: obj[key].acessorios,
                tamanho: obj[key].tamanho,
                laminas: obj[key].laminas,
                extras: obj[key].extras,
                obs: obj[key].obs,
                valor: obj[key].valor,
                save: obj[key].save,
              });
            }
          }
          commit("setCalcs", calcs);
        } else {
          console.log("Dados não encontrados.");
          commit("setCalcs", []);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
  saveCalc({ commit }, obj) {
    const db = getDatabase(firebaseApp);
    let key;
    push(ref(db, "calcs/"), obj)
      .then((data) => {
        key = data.key;
        return key;
      })
      .then((key) => {
        commit("saveCalc", key);
      });
  },
  deleteCalc({ commit }, id) {
    const db = getDatabase(firebaseApp);
    const updates = {};
    updates["calcs/" + id] = null;
    update(ref(db), updates);
    commit("deleteCalc", id);
  },
  setOrcamento({ commit }, obj) {
    commit("setOrcamento", obj);
  },
};

const mutations = {
  setCalcs(state, obj) {
    state.calcs = obj;
  },
  deleteCalc(id) {
    console.log(id);
  },
  saveCalc(id) {
    console.log(!!id);
  },
  setOrcamento(state, obj) {
    state.orcamento = obj;
  },
  setShowMostruario(state, value) {
    state.showMostruario = value;
  },
  setMostruario(state, value) {
    state.mostruario = value;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
